import { Component, Input, OnInit } from '@angular/core';
import { DiagnosticResult, DiagnosticFinding, FillStatus } from '../../models/diagnostic.models';
import {
  StepEntry, initEarlyExitCard,
  safe, labelFor, formatValue, formatMoney, formatNumber, formatFillRate,
  isPrimitive, isArrayOfObjects, isPlainObject,
  primitiveEntries, tableEntries, objectEntries, tableColumns,
  step1BudgetPct, step1BarColor, step0StatusTone,
  fillRateBarColor, fillRatePct, fillStatusClass, fillStatusDot,
  step6OverallStatus, step6Headline, step6SortedSummary, step6NoDeliveryCount,
  step5HasMatch,
  donutPath, donutColor, donutDisplay, donutRadius, donutCircumference, donutOffset,
  severity as calcSeverity, completionHeadline as calcCompletionHeadline,
  findingsByType as filterFindingsByType,
  findingDotColor, stepConfigFor, stepAccentClass, stepNumber,
  toggleInMap
} from './early-exit-card.utils';

@Component({
  selector: 'app-early-exit-card',
  templateUrl: './early-exit-card.component.html',
  styleUrls: ['./early-exit-card.component.scss']
})
export class EarlyExitCardComponent implements OnInit {
  @Input() data: DiagnosticResult = {} as DiagnosticResult;
  readonly String = String;

  stepEntries: StepEntry[] = [];
  otherEntries: [string, any][] = [];
  isCompletion = false;
  findings: DiagnosticFinding[] = [];
  openSteps: Record<string, boolean> = {};
  showStoresMap: Record<string, boolean> = {};
  showDetailsMap: Record<string, boolean> = {};

  readonly stepTitles: Record<number, string> = {
    0: 'Paso 0 · Estado',
    1: 'Paso 1 · Budget',
    2: 'Paso 2 · Ads escritos',
    3: 'Paso 3 · Combinaciones',
    4: 'Paso 4 · Keywords',
    5: 'Paso 5 · Stock'
  };

  readonly statusLabels: Record<FillStatus, string> = {
    delivering: 'Delivering',
    exhausted: 'Exhausted',
    no_delivery: 'No delivery',
    no_data: 'No data'
  };

  ngOnInit(): void {
    const state = initEarlyExitCard(this.data);
    this.isCompletion = state.isCompletion;
    this.stepEntries = state.stepEntries;
    this.openSteps = state.openSteps;
    this.otherEntries = state.otherEntries;
    this.findings = state.findings;
  }

  toggleStep(key: string): void { toggleInMap(this.openSteps, key); }
  toggleStores(key: string): void { toggleInMap(this.showStoresMap, key); }
  toggleDetails(key: string): void { toggleInMap(this.showDetailsMap, key); }

  severity(): 'ok' | 'warning' | 'critical' { return calcSeverity(this.findings); }
  completionHeadline(): string { return calcCompletionHeadline(this.findings); }
  findingsByType(sev: string): DiagnosticFinding[] { return filterFindingsByType(this.findings, sev); }

  readonly safe = safe;
  readonly labelFor = labelFor;
  readonly formatValue = formatValue;
  readonly formatMoney = formatMoney;
  readonly formatNumber = formatNumber;
  readonly formatFillRate = formatFillRate;
  readonly isPrimitive = isPrimitive;
  readonly isArrayOfObjects = isArrayOfObjects;
  readonly isPlainObject = isPlainObject;
  readonly primitiveEntries = primitiveEntries;
  readonly tableEntries = tableEntries;
  readonly objectEntries = objectEntries;
  readonly tableColumns = tableColumns;
  readonly step1BudgetPct = step1BudgetPct;
  readonly step1BarColor = step1BarColor;
  readonly step0StatusTone = step0StatusTone;
  readonly fillRateBarColor = fillRateBarColor;
  readonly fillRatePct = fillRatePct;
  readonly fillStatusClass = fillStatusClass;
  readonly fillStatusDot = fillStatusDot;
  readonly step6OverallStatus = step6OverallStatus;
  readonly step6Headline = step6Headline;
  readonly step6SortedSummary = step6SortedSummary;
  readonly step6NoDeliveryCount = step6NoDeliveryCount;
  readonly step5HasMatch = step5HasMatch;
  readonly donutPath = donutPath;
  readonly donutColor = donutColor;
  readonly donutDisplay = donutDisplay;
  readonly donutRadius = donutRadius;
  readonly donutCircumference = donutCircumference;
  readonly donutOffset = donutOffset;
  readonly findingDotColor = findingDotColor;
  readonly stepConfigFor = stepConfigFor;
  readonly stepAccentClass = stepAccentClass;
  readonly stepNumber = stepNumber;
}
